import { SnapData } from './snaplines'
import { Line } from '@react-three/drei'
import theme from '~/config/theme'

export function SnapLine(props: { snapPoint: SnapData; zOverride?: number }) {
  const { objectLine, previousObjectLine, snapPoint } = props.snapPoint
  const p1 = objectLine.start.clone().setZ(props.zOverride ?? objectLine.start.z)
  const p2 = objectLine.end.clone().setZ(props.zOverride ?? objectLine.end.z)

  const other = p1.distanceToSquared(snapPoint) < p2.distanceToSquared(snapPoint) ? p2 : p1

  return (
    <>
      <Line color={theme.colors.three.valid} linewidth={2} points={[p1, p2]} />
      <Line color={theme.colors.three.valid} linewidth={2} dashed points={[snapPoint, other]} />
      {previousObjectLine &&
        (() => {
          const p1 = previousObjectLine.start.clone().setZ(props.zOverride ?? previousObjectLine.start.z)
          const p2 = previousObjectLine.end.clone().setZ(props.zOverride ?? previousObjectLine.end.z)

          const other = p1.distanceToSquared(snapPoint) < p2.distanceToSquared(snapPoint) ? p2 : p1

          return (
            <>
              <Line color={theme.colors.three.valid} linewidth={2} points={[p1, p2]} />
              <Line color={theme.colors.three.valid} linewidth={2} dashed points={[snapPoint, other]} />
            </>
          )
        })()}
    </>
  )
}
